__turbopack_context__.v({
  "className": "noto_sans_jp_3f9f519a-module__iZ-vbG__className",
});
